export const getSkuFromQueryParams = (): string | undefined => {
  const queryParams = new URLSearchParams(window.location.search);
  const sku = queryParams.get('sku');

  return sku || undefined;
};

export default {getSkuFromQueryParams};
